<template>
  <section class="ma-0">
    <v-row align="center" justify="start" no-gutter dense class="px-2 ma-0">
      <v-col cols="12">
        <v-divider />
      </v-col>
      <v-col cols="12" class="text-center text-overline">
        <p>2021 © MARJ</p>
        <p class="mt-n6">All rights reserved.</p>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style></style>
